<template>
  <el-dialog
    v-loading="loading"
    :element-loading-text="$t('989')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    append-to-body
    :title="uploadStatus ? $t('653') : $t('holiday_rest_6')"
    :visible.sync="visible"
    v-if="visible"
    @close="closeHandle"
    :close-on-click-modal="false"
    width="800px"
  >
    <section style="text-align: center; color: #409eff" v-if="uploadStatus">
      <p v-if="uploadStatus">
        {{ $t('978') }}:
        {{
          $t('654', {
            x: uploadTotalCount,
            y: uploadSuccessCount,
            z: uploadFailCount
          })
        }}
      </p>
      <p
        v-if="feedbackFileUrl"
        style="text-decoration: underline; margin-top: 10px; cursor: pointer"
        @click="handleOpenUrl"
      >
        {{ $t('934') }}
      </p>
    </section>
    <template v-else>
      <section>
        <p>1: {{ $t('holiday_rest_7') }}</p>
        <span class="upload-dialog-des">{{ $t('46') }}</span>
        <el-row>
          <el-col :span="8">
            <el-button class="el-icon-download" @click="handleExport">{{ $t('holiday_rest_8') }}</el-button>
          </el-col>
        </el-row>
      </section>
      <section>
        <p>2: {{ $t('holiday_rest_9') }}</p>
        <el-upload
          class="upload-demo"
          drag
          ref="upload"
          :action="uploadUrl"
          :file-format="fileFormat"
          :multiple="multiple"
          :headers="baseHeaders"
          :before-upload="beforeUploadHandle"
          :on-success="successHandle"
          :on-error="errorHandle"
          :show-file-list="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <em>{{ $t('728') }}</em>
          </div>
          <div class="el-upload__tip" slot="tip">{{ $t('40') }}</div>
        </el-upload>
      </section>
    </template>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button v-if="uploadStatus" @click="visible = false">{{ $t('285') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { baseHeaders } from 'util/axios-request'
import { exportLeaveDays } from 'api/approval/config'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  data() {
    return {
      loading: false,
      visible: false,
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      uploadUrl: baseURL + 'web/leave/importLeaveDays',
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadStatus: false,
      uploadTotalCount: 0, // 总数
      uploadSuccessCount: 0, // 成功数
      uploadFailCount: 0, // 失败数
      feedbackFileUrl: '',
      form: {
        name: ''
      }
    }
  },
  methods: {
    init() {
      this.resetDate()
      this.visible = true
    },
    async handleExport() {
      this.loading = true
      exportLeaveDays()
        .then(res => {
          this.loading = false
          if (res && res.code === 1) window.open(res.data.template_url)
        })
        .catch(e => {
          this.loading = false
        })
    },
    async beforeUploadHandle(file) {
      const res = await this.$confirm(this.$t('holiday_rest_11'), this.$t('holiday_rest_12'), {
        confirmButtonText: this.$t('holiday_rest_10'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
      if (res === 'confirm') this.loading = true
    },
    // 上传成功+
    successHandle(res, file) {
      if (this.$refs.upload.uploadFiles.length > 1) {
        this.$refs.upload.uploadFiles.splice(0, 1)
      }
      this.uploadTotalCount = 0 // 总数
      this.uploadSuccessCount = 0 // 成功数
      this.uploadFailCount = 0 // 失败数
      const response = res
      const data = response.data
      this.loading = false
      if (response && response.code === 1) {
        this.uploadStatus = true
        if (data.upload_result_state === 1) {
          // 全部成功
          this.uploadTotalCount = data.upload_total_count
          this.uploadSuccessCount = data.upload_success_count
          this.uploadFailCount = data.upload_fail_count
          this.$message.success(this.$t('935'))
          this.feedbackFileUrl = ''
        } else if (data.upload_result_state === 5) {
          // 部分成功
          this.uploadTotalCount = data.upload_total_count
          this.uploadSuccessCount = data.upload_success_count
          this.uploadFailCount = data.upload_fail_count
          this.feedbackFileUrl = data.feedback_file_url
          this.$message.error(this.$t('936'))
        } else if (data.upload_result_state === 3) {
          // 全部失败
          this.uploadTotalCount = data.upload_total_count
          this.uploadSuccessCount = data.upload_success_count
          this.uploadFailCount = data.upload_fail_count
          this.feedbackFileUrl = data.feedback_file_url
          this.$message.error(this.$t('937'))
        }
      } else {
        this.$message.error(res.message)
      }
    },
    handleOpenUrl() {
      window.open(this.feedbackFileUrl)
    },
    // 上传失败
    // err, file, fileList
    errorHandle(err, file) {
      this.loading = false
      const index = this.$refs.upload.uploadFiles.findIndex(v => v.name === file.name)
      this.$refs.upload.uploadFiles.splice(index, 1)
      this.$message.error(this.$t('upload_error'))
      throw err
    },
    resetDate() {
      this.uploadTotalCount = 0 // 总数
      this.uploadSuccessCount = 0 // 成功数
      this.uploadFailCount = 0 // 失败数
      this.feedbackFileUrl = ''
      this.uploadStatus = false
    },
    // 弹窗关闭时
    closeHandle() {
      this.reset()
      this.resetDate()
    },
    reset() {
      this.$refs.upload && this.$refs.upload.clearFiles()
      this.successFileList = []
    },
    doSubmit() {
      this.visible = false
      this.resetDate()
      this.$emit('submit')
    }
  },
  watch: {
    successFileList: {
      handler(val) {
        if (val.length) this.$emit('uploadSuccess', val)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog {
  position: relative;
  .tip {
    font-size: 12px;
    color: red;
    position: absolute;
    left: 174px;
    top: 25px;
  }
}
section {
  margin-bottom: 20px;
}
.upload-dialog-des {
  display: block;
  font-size: 12px;
  line-height: 30px;
  color: #ccc;
}
.upload-demo {
  margin-top: 15px;
  text-align: center;
  /deep/ .el-upload-list {
    .el-progress {
      display: none;
    }
    .el-icon-upload-success {
      display: none;
    }
  }
}
</style>
